<template>
  <div class="upload-component">
    <div class="total">
      <div class="text-container">
        <div class="sub-title">
          <span>{{ name }}</span>
          <span v-if="required" class="star">*</span>
        </div>
      </div>
      <div class="upload-invoice">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String
    },
    /* 是否必填 */
    required: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
    }
  },

  created() {},

  methods: {
  }
}
</script>

<style lang='scss'>

</style>
